import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import {
  hasTooManyActiveWarehouseContacts,
  hasValidFieldsInAdditionalContacts,
  isActiveWarehouseContact,
  isValidEmail,
} from "../../helper/ContactValidationUtilities";
import {
  deleteService,
  getJsonResult,
  put,
} from "../../services/FetchServices";
import AdditionalContactDetails from "../../types/AdditionalContactDetails";
import Location from "../../types/Location";
import SelectedAddressDetails from "../../types/SelectedAddressDetails";
import AddressPrompt from "../AddressPrompt";
import { DropDown } from "../dropDown/DropDown";
import AdditionalContacts from "../newLocation/AdditionalContacts";
import {
  FlagableButton,
  focusOnButton,
} from "../purchaseOrderRelease/FlagableButton";
import {
  FlagableTextField,
  focusOnField,
} from "../purchaseOrderRelease/FlagableTextField";
import LocationAvailability from "./LocationAvailability";

interface IState {
  location?: Location;
  searchLocation?: Location;
}

const NewLocationPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  let contactTypes = ["RELEASE_SUMMARY", "TENDER", "WAREHOUSE"];
  const loc = (location?.state as IState)?.location;
  const isCreateFlow = !loc;
  const searchLocation = (location?.state as IState)?.searchLocation;
  var selectedAddressDetails = new SelectedAddressDetails(
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  );
  const [addressDetails, setAddressDetails] = useState<SelectedAddressDetails>(
    new SelectedAddressDetails("", "", "", "", "", "", ""),
  );
  var isValidateButtonEnabled = false;
  const [isCreateLocationButtonEnabled, setIsCreateLocationButtonEnabled] =
    useState(false);
  var isUpdateLocationButtonEnabled = false;
  const [isAllContactTypesAreSelected, setIsAllContactTypesAreSelected] =
    useState(false);
  const [isAllContactTypesAreActive, setIsAllContactTypesAreActive] =
    useState(false);
  const [locationName, setLocationName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [contactName, setContactName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [remark, setRemark] = useState("");
  const [refNumVal, setRefNumVal] = useState<string>("");
  const [locAvailability, setLocAvailability] = useState<string>(
    loc ? loc.locationAvailability : "",
  );
  const [additionalAddress, setAdditionalAddress] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedLatitude, setSelectedLatitude] = useState("");
  const [selectedLongitude, setSelectedLongitude] = useState("");
  const [selectedTimeZone, setSelectedTimeZone] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [countryCodes, setCountryCodes] = useState(["USA", "CAN", "MEX"]);
  const [calenderIds, setCalenderIds] = useState(["VENDOR_WEEKDAY_8TO5"]);
  const [countryCode, setCountryCode] = useState("USA");
  const [calenderId, setCalenderId] = useState("VENDOR_WEEKDAY_8TO5");
  const [validatedAddrResult, setValidatedAddrResult] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [showValidatedAddressPrompt, setShowValidatedAddressPrompt] =
    useState(false);
  const [showInputText, setShowInputText] = useState(true);
  const [facilityId, setFacilityId] = useState("C" + Date.now().toString()); // Generates a facility ID prefixed with "C" followed by the current timestamp for MATM
  const [isMatm, setIsMatm] = useState(true); // Boolean state variable to indicate if the current mode is MATM (true) or OTM (false)

  const [isFetchingData, setIsFetchingData] = useState(false);
  const [isAddressValidated, setAddressValidation] = useState(true);
  const [isAdditionalAddress, setIsAdditionalAddress] = useState(true);
  const [isValidLocationName, setIsValidLocationName] = useState(true);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [isValidRemarks, setIsValidRemarks] = useState(true);
  const [openAlert, setAlertOpen] = useState(false);
  const [openFailureAlert, setFailureAlertOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [validationAlert, setValidationAlert] = useState(false);
  const [facilityType, setFacilityType] = useState("VENDOR_MANAGED");
  const [isValidFacilityType, setIsValidFacilityType] = useState(true);
  const [releaseSummaryContacts, setReleaseSummaryContacts] = useState<
    AdditionalContactDetails[]
  >([]);
  const [tenderContacts, setTenderContacts] = useState<
    AdditionalContactDetails[]
  >([]);
  const [warehouseContacts, setWarehouseContacts] = useState<
    AdditionalContactDetails[]
  >([]);
  const [vendorResponsibleContacts, setVendorResponsibleContacts] = useState<
    AdditionalContactDetails[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  var username = localStorage.getItem("userName");
  var authHeader = localStorage.getItem("authHeader");

  useEffect(() => {
    if (!loc) {
      setReleaseSummaryContacts([]);
      setTenderContacts([]);
      setWarehouseContacts([]);
      setVendorResponsibleContacts([]);
      setFacilityType("VENDOR_MANAGED");
    }
  }, [loc]);

  const validateAddress = () => {
    setIsFetchingData(true);

    var pcmValidateAddressUrl = `${
      process.env.REACT_APP_BACKEND_URL
    }/validate-address/pcm?address=${
      address + "+" + postalCode + "+" + countryCode
    }`;
    if (address)
      getJsonResult(pcmValidateAddressUrl)
        .then((response) => response.json())
        .then((data) => {
          const results = data.locations;
          setValidatedAddrResult(
            data.status === "ZERO_RESULTS"
              ? "No Results"
              : results[0]?.shortString,
          );
          const timeZoneMap: Record<string, string> = {
            // Eastern
            EST: "America/New_York",
            EDT: "America/New_York",
            // Central
            CST: "America/Chicago",
            CDT: "America/Chicago",
            // Mountain
            MST: "America/Phoenix",
            MDT: "America/Denver",
            // Pacific
            PST: "America/Los_Angeles",
            PDT: "America/Los_Angeles",
            // Alaska
            AKST: "America/Anchorage",
            AKDT: "America/Anchorage",
            // Hawaii / Aleutian
            HDT: "America/Adak",
            HST: "Pacific/Honolulu",
            // Atlantic
            AST: "America/Halifax",
            ADT: "America/Halifax",
            // Newfoundland
            NST: "America/St_Johns",
            NDT: "America/St_Johns",
          };
          var isValidAddress = false;
          if (data.status !== "ZERO_RESULTS") {
            var address = results[0]?.address;
            var coords = results[0]?.coords;
            var timeZone = results[0]?.timeZone;
            if (typeof coords?.lat && coords.lat.trim().length > 0) {
              selectedAddressDetails.latitude = coords.lat;
            }
            if (typeof coords?.lon && coords.lon.trim().length > 0) {
              selectedAddressDetails.longitude = coords.lon;
            }
            if (typeof timeZone === "string" && timeZone.trim().length > 0) {
              const parts = timeZone.trim().split(/\s+/);
              const code = parts[parts.length - 1].toUpperCase();

              selectedAddressDetails.timeZone = timeZoneMap[code] ?? timeZone;
            }
            if (
              typeof address?.streetAddress === "string" &&
              address.streetAddress.trim().length > 0
            ) {
              isValidAddress = true;
              selectedAddressDetails.streetAddress =
                address.streetAddress.trim();
            }
            if (
              typeof address?.city === "string" &&
              address.city.trim().length > 0
            ) {
              selectedAddressDetails.city = address.city;
            }
            if (
              typeof address?.state === "string" &&
              address.state.trim().length > 0
            ) {
              selectedAddressDetails.provinceCode = address.state;
            }
            if (
              typeof address?.zip === "string" &&
              address.zip.trim().length > 0
            ) {
              selectedAddressDetails.postalCode = address.zip;
            }
            if (
              typeof address?.country === "string" &&
              address.country.trim().length > 0
            ) {
              var country = address.country;
              if (country === "CA") {
                setCountryCode("CAN");
              } else if (country === "US") {
                setCountryCode("USA");
              } else if (country === "MX") {
                setCountryCode("MEX");
              }
            }
          }
          if (isValidAddress) {
            setAddressDetails(selectedAddressDetails);

            setShowValidatedAddressPrompt(true);
            setTimeout(() => setIsFetchingData(false), 1000);
          } else {
            setIsFetchingData(false);
            setDialogContent("Please enter the valid address!!!");
            setDialogTitle("Validation error!");
            setValidationAlert(true);
          }
        })
        .catch((err) => console.log(err));
  };

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const closeAlertDialog = () => {
    setAlertOpen(false);
    history.push("/findLocation");
  };

  const closeValidationAlert = () => {
    setValidationAlert(false);
  };

  const createOrUpdateLocation = (flag: string) => {
    let domain = username?.substring(0, 2);
    var locationXid = "";
    var locationGid = "";
    if (flag === "create") {
      let locationId = hashCode(vendorId + postalCode + address).toString();
      locationXid = locationId.toString();
      locationGid = domain + "." + locationId;
    } else if (flag === "update") {
      locationXid = loc?.locationXId!;
      locationGid = loc?.locationGId!;
    }

    let operation = "IU";
    let deleteOperation = "CD";
    let primaryContactNames = contactName.split(" ");
    let primaryContact = {
      transactionCode: operation,
      primaryContactBeanData: {
        contactGid: locationGid,
        contactXid: locationXid,
        firstName: primaryContactNames[0].toUpperCase(),
        lastName: primaryContactNames[1]
          ? primaryContactNames[1].toUpperCase()
          : "",
        emailAddress: emailAddress.toUpperCase(),
        phone1: phoneNumber,
        isPrimaryContact: true,
        contactType: "PERSON",
        locationGid: locationGid,
        domainName: domain,
        userName: username,
        contactComMethod: [
          {
            transactionCode: operation,
            contactComMethodBeanData: {
              contactGid: locationGid,
              comMethodRank: 1,
              comMethodGid: "EMAIL",
              domainName: domain,
            },
          },
        ],
      },
    };

    let contacts = [];
    contacts.push(primaryContact);
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }

    additionalContactsList.forEach((contact) => {
      let contactNames = contact.contactName.split(" ");
      contacts.push({
        transactionCode: contact.operation,
        primaryContactBeanData: {
          contactGid: domain + "." + contact.contactXid,
          contactXid: contact.contactXid,
          firstName: contactNames[0].toUpperCase(),
          lastName: contactNames[1] ? contactNames[1].toUpperCase() : "",
          jobTitle: contact.jobTitle.toUpperCase(),
          emailAddress: contact.emailAddress.toUpperCase(),
          phone1: contact.phone1,
          isPrimaryContact: false,
          contactType: "PERSON",
          locationGid: locationGid,
          isNotificationOn: contact.active,
          domainName: domain,
        },
      });
    });

    let primaryAddress = {
      transactionCode: operation,
      locationAddressBeanData: {
        locationGid: locationGid,
        lineSequence: 1,
        addressLine: address.toUpperCase(),
        domainName: domain,
      },
    };

    let locationAddress = [];
    locationAddress.push(primaryAddress);
    if (additionalAddress !== "") {
      let secondaryAddress = {
        transactionCode: operation,
        locationAddressBeanData: {
          locationGid: locationGid,
          lineSequence: 2,
          addressLine: additionalAddress ? additionalAddress.toUpperCase() : "",
          domainName: domain,
        },
      };
      locationAddress.push(secondaryAddress);
    }

    let locationRoleProfile = [
      {
        transactionCode: operation,
        locationRoleProfileBeanData: {
          locationGid: locationGid,
          locationRoleGid: "SHIPFROM/SHIPTO",
          calendarGid: domain + "." + calenderId,
          domainName: domain,
        },
      },
    ];

    let locationRemark = [
      {
        transactionCode: operation,
        locationRemarkBeanData: {
          locationGid: locationGid,
          remarkSequence: 1,
          remarkQualGid: domain + ".REMARK",
          remarkText: remark ? remark.toUpperCase() : "",
          domainName: domain,
        },
      },
    ];

    let locationRefnum = [];
    // if (locAvailability) {
    //   let previousAvailability = {
    //     transactionCode: deleteOperation,
    //     locationRefnumBeanData: {
    //       locationGid: locationGid,
    //       locationRefnumQualGid: domain + ".VENDOR_HOURS",
    //       locationRefnumValue: locAvailability,
    //       domainName: domain,
    //     },
    //   };
    //   locationRefnum.push(previousAvailability);
    // }
    let currentAvailability = {
      transactionCode: operation,
      locationRefnumBeanData: {
        locationGid: locationGid,
        locationRefnumQualGid: domain + ".VENDOR_HOURS",
        locationRefnumValue: refNumVal ? refNumVal : "00:00-00:00",
        domainName: domain,
      },
    };
    locationRefnum.push(currentAvailability);

    const updateDate = {
      date: loc?.updateDate,
    };

    let createLocationJson = {
      Location: {
        vendorId: localStorage.getItem("vendorId"),
        timeZone: selectedTimeZone,
        latitude: selectedLatitude,
        longitude: selectedLongitude,
        locationGid: locationGid,
        locationXid: locationXid,
        facilityId: isMatm ? facilityId : undefined, // Set facilityId if in MATM mode(isMatm is true); otherwise, set it to undefined.
        locationName: locationName.toUpperCase(),
        city: selectedCity.toUpperCase(),
        provinceCode: selectedState,
        postalCode: postalCode,
        countryCode3Gid: countryCode,
        attribute1: vendorId,
        primaryAddressLineSeq: 1,
        isActive: isActive,
        domainName: domain,
        userName: username,
        primaryContact: contacts,
        locationRefnum: locationRefnum,
        locationAddress: address ? locationAddress : [],
        locationRoleProfile: calenderId ? locationRoleProfile : [],
        locationRemark: remark ? locationRemark : [],
      },
    };

    let updateLocationJson = {
      Location: {
        vendorId: localStorage.getItem("vendorId"),
        timeZone: selectedTimeZone,
        latitude: selectedLatitude,
        longitude: selectedLongitude,
        locationGid: locationGid,
        locationXid: locationXid,
        facilityId: locationGid,
        locationName: locationName.toUpperCase(),
        city: selectedCity.toUpperCase(),
        provinceCode: selectedState,
        postalCode: postalCode,
        facilityType: facilityType,
        countryCode3Gid: countryCode,
        attribute1: vendorId,
        primaryAddressLineSeq: 1,
        isActive: isActive,
        domainName: domain,
        userName: username,
        primaryContact: contacts,
        locationRefnum: locationRefnum,
        locationAddress: address ? locationAddress : [],
        locationRoleProfile: calenderId ? locationRoleProfile : [],
        locationRemark: remark ? locationRemark : [],
        updateDate: updateDate,
        createdBy: loc?.createdBy,
      },
    };

    validateContactTypesSelected();
    validateContactTypesActive();
    validateFaclityType();
    if (!isAllContactTypesAreSelected || !isAllContactTypesAreActive) return;
    if (flag === "create") {
      //console.log("createLocationJson **********", createLocationJson);
      var createLocationUrl = isMatm // Use a ternary operator to check if the mode is MATM
        ? `${process.env.REACT_APP_BACKEND_URL}/matm/findLocation/save` // If true, create the URL for the MATM save endpoint, including the authentication header
        : `${process.env.REACT_APP_BACKEND_URL}/findLocation/save?authHeader=` +
          authHeader; // If false, create the URL for the OTM save endpoint, including the authentication header
      put(createLocationUrl, createLocationJson)
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.text();
          } else {
            throw response;
          }
        })
        .then((data) => {
          setDialogContent("Location successfully created");
          setDialogTitle("Success!");
          setAlertOpen(true);
        })
        .catch((error) => {
          error.text().then((errMessage: any) => {
            setDialogContent("Error when creating location:\n" + errMessage);
          });
          setDialogTitle("Error!");
          setAlertOpen(true);
        });
    } else if (flag === "update") {
      var updateLocationUrl =
        `${process.env.REACT_APP_BACKEND_URL}/matm/findLocation/update?facilityId=` +
        locationGid;
      put(updateLocationUrl, updateLocationJson)
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.text();
          } else {
            throw response;
          }
        })
        .then((data) => {
          setDialogContent("Location successfully updated");
          setDialogTitle("Success!");
          setAlertOpen(true);
        })
        .catch((error) => {
          error.text().then((errMessage: any) => {
            setDialogContent("Error when updating location:\n" + errMessage);
          });
          setDialogTitle("Error!");
          setAlertOpen(true);
        });
    }
  };

  const deleteLocation = () => {
    closeDialog();
    const deleteLocationUrl =
      `${process.env.REACT_APP_BACKEND_URL}/matm/findLocation/deleteLocation?vendorId=` +
      vendorId +
      "&locationGId=" +
      loc?.locationGId!;
    deleteService(deleteLocationUrl)
      .then((response) => {
        if (response.status == 200) {
          return response.text();
        } else {
          throw response;
        }
      })
      .then((data) => {
        setDialogContent("Location successfully deleted");
        setDialogTitle("Success!");
        setAlertOpen(true);
      })
      .catch((error) => {
        error.text().then((errMessage: any) => {
          setAlertOpen(true);
          setDialogContent(
            "This location is tied to an order release and cannot be deleted.",
          );
          setDialogTitle("Error!");
        });
      });
  };

  function hashCode(myString: string) {
    var encode = require("hashcode").hashCode;
    var hash = encode().value(myString);
    if (hash < 0) {
      hash = hash * -1;
    }
    return hash;
  }

  const handleStreetAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newAddress = e.target.value.replace(
      /[^a-zA-Z0-9-,.;_=+()!@#$%{}[\]|/\\^\s)]/g,
      "",
    );
    setAddress(newAddress);
    if (newAddress.length > 55) {
      setAddressValidation(false);
    } else {
      setAddressValidation(true);
    }
  };

  const handlePostalCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostalCode(
      e.target.value.replace(/[^a-zA-Z0-9-,.;_=+()!@#$%{}[\]|/\\^\s]/g, ""),
    );
  };

  const handleLocationName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLocationName = e.target.value.replace(
      /[^a-zA-Z0-9-,.;_=+()!@#$%{}[\]|/\\^\s]/g,
      "",
    );
    setLocationName(newLocationName);
    if (newLocationName.length > 50) {
      setIsValidLocationName(false);
    } else {
      setIsValidLocationName(true);
    }
  };

  const handleIsActive = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.checked);
  };

  const handleContactName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactName(
      e.target.value.replace(/[^a-zA-Z0-9-,.;_=+()!@#$%{'}[\]|/\\^\s]/g, ""),
    );
  };

  const handleEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailAddress(e.target.value);
  };

  const handlePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPhoneNumber = e.target.value.replace(/[^0-9]/g, "");
    setPhoneNumber(newPhoneNumber);
    if (
      newPhoneNumber.trim().length === 0 ||
      newPhoneNumber.trim().length === 10
    ) {
      setIsValidPhoneNumber(true);
    } else {
      setIsValidPhoneNumber(false);
    }
  };

  const handleCalenderId = (e: any) => {
    setCalenderId(e.target.value);
  };

  const createDefaultVendorResponsibleContact = () => {
    const timestamp = Date.now();
    return new AdditionalContactDetails(
      "",
      `VR${timestamp}`,
      "",
      "VENDOR_RESPONSIBLE",
      "",
      "",
      "IU",
      true,
      true,
    );
  };

  const handleFacilityType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFacilityType = e.target.value;
    setFacilityType(selectedFacilityType);
    if (selectedFacilityType === "VENDOR_MANAGED") {
      setVendorResponsibleContacts([]);
    } else if (
      selectedFacilityType === "VENDOR_RESPONSIBLE" &&
      vendorResponsibleContacts.length === 0
    ) {
      setVendorResponsibleContacts([createDefaultVendorResponsibleContact()]);
    }
  };

  const handleRemark = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newRemark = e.target.value.replace(
      /[^a-zA-Z0-9-,.;_=+()!@#$%{'}[\]|/\\^\s]/g,
      "",
    );
    setRemark(newRemark);
    if (newRemark.length > 80) {
      setIsValidRemarks(false);
    } else {
      setIsValidRemarks(true);
    }
  };

  const handleAdditionalAddress = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const newAdditionalAddress = e.target.value.replace(
      /[^a-zA-Z0-9-,.;_=+()!@#$%{'}[\]|/\\^\s]/g,
      "",
    );
    setAdditionalAddress(newAdditionalAddress);
    if (newAdditionalAddress.length > 50) {
      setIsAdditionalAddress(false);
    } else {
      setIsAdditionalAddress(true);
    }
  };

  const togglingPrompt = () => {
    setShowValidatedAddressPrompt(!showValidatedAddressPrompt);
  };

  const onSelectedAddress = () => {
    setShowValidatedAddressPrompt(!showValidatedAddressPrompt);
    setAddress(addressDetails.streetAddress);
    setShowInputText(addressDetails.city.length > 0 ? false : true);
    setPostalCode(addressDetails.postalCode);
    setSelectedState(addressDetails.provinceCode);
    setSelectedCity(addressDetails.city);
    setSelectedLatitude(addressDetails.latitude);
    setSelectedLongitude(addressDetails.longitude);
    setSelectedTimeZone(addressDetails.timeZone);
    setAddressValidation(true);
    setIsLoading(false);
  };

  const updateReleaseSummaryContactList = (
    list: AdditionalContactDetails[],
  ) => {
    setReleaseSummaryContacts([...list]);
  };

  const updateTenderContactList = (list: AdditionalContactDetails[]) => {
    setTenderContacts([...list]);
  };

  const updateWarehouseContactList = (list: AdditionalContactDetails[]) => {
    setWarehouseContacts([...list]);
  };

  const updateVendorResponsibleContactList = (
    list: AdditionalContactDetails[],
  ) => {
    setVendorResponsibleContacts([...list]);
  };

  const updateRefNumVal = (refNumVal: string) => {
    setRefNumVal(refNumVal);
  };

  useEffect(() => {
    setVendorId(localStorage.getItem("vendorId")!);
  }, []);

  useEffect(() => {
    if (loc !== undefined) {
      setAddress(loc?.streetAddress);
      setPostalCode(loc?.postalCode);
      setSelectedState(loc?.provinceCode);
      setSelectedCity(loc?.city);
      setSelectedLatitude(loc?.latitude);
      setSelectedLongitude(loc?.longitude);
      setSelectedTimeZone(loc?.timeZone);
      setLocationName(loc?.locationName);
      setIsActive(loc?.isActive);
      setContactName(loc?.contactName);
      setPhoneNumber(loc?.phoneNumber);
      setEmailAddress(loc?.emailAddress);
      setRemark(loc?.remark);
      setAdditionalAddress(loc?.additionalAddress);
      // setAdditionalContactsList(loc?.primaryContact);
      setLocAvailability(loc?.locationAvailability);
      setCountryCode(loc?.countryCode3GId ? loc?.countryCode3GId : "USA");
      setFacilityType(loc?.facilityType);

      const releaseSummaryCont: AdditionalContactDetails[] = [];
      const tenderCont: AdditionalContactDetails[] = [];
      const warehouseCont: AdditionalContactDetails[] = [];
      const vendorResponsibleCont: AdditionalContactDetails[] = [];
      loc?.primaryContact?.forEach((contact) => {
        if (contact.jobTitle === "RELEASE_SUMMARY") {
          releaseSummaryCont.push({ ...contact });
        } else if (contact.jobTitle === "TENDER") {
          tenderCont.push({ ...contact });
        } else if (contact.jobTitle === "WAREHOUSE") {
          warehouseCont.push({ ...contact });
        } else if (contact.jobTitle === "VENDOR_RESPONSIBLE") {
          vendorResponsibleCont.push({ ...contact });
        }
      });

      if (vendorResponsibleCont.length > 0) {
        setFacilityType("VENDOR_RESPONSIBLE");
      } else {
        setFacilityType("VENDOR_MANAGED");
      }

      setReleaseSummaryContacts(releaseSummaryCont);
      setTenderContacts(tenderCont);
      setWarehouseContacts(warehouseCont);
      setVendorResponsibleContacts(vendorResponsibleCont);
      setIsLoading(false);
    }
  }, [loc]);

  isValidateButtonEnabled = validateMandatoryFields();
  function validateMandatoryFields() {
    if (address && postalCode && isAddressValidated && showInputText) {
      return true;
    }
    return false;
  }

  function validateAllMandatoryFields() {
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }
    const requiresVendorResponsibleContact =
      facilityType === "VENDOR_RESPONSIBLE" && !isCreateFlow;
    const vendorResponsibleNotAllowed = facilityType === "VENDOR_MANAGED";
    const vendorResponsibleRequirementMet = requiresVendorResponsibleContact
      ? vendorResponsibleContacts.length > 0
      : true;
    const vendorResponsibleCleanForVendorManaged = vendorResponsibleNotAllowed
      ? vendorResponsibleContacts.length === 0
      : true;

    if (
      address &&
      locationName &&
      isValidLocationName &&
      // contactName &&
      // emailAddress &&
      // isValidEmail(emailAddress) &&
      // phoneNumber &&
      // isValidPhoneNumber &&
      isAllContactTypesAreSelected &&
      isAllContactTypesAreActive &&
      isValidRemarks &&
      selectedCity &&
      selectedState &&
      facilityType &&
      isAddressValidated &&
      isAdditionalAddress &&
      hasValidFieldsInAdditionalContacts(additionalContactsList) &&
      vendorResponsibleRequirementMet &&
      vendorResponsibleCleanForVendorManaged
    ) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    validateContactTypesSelected();
    validateContactTypesActive();
  }, [
    releaseSummaryContacts,
    tenderContacts,
    warehouseContacts,
    vendorResponsibleContacts,
    facilityType,
  ]);

  useEffect(() => {
    setIsCreateLocationButtonEnabled(validateAllMandatoryFields());
    isUpdateLocationButtonEnabled = validateUpdateAllMandatoryFields();
  }, [
    releaseSummaryContacts,
    tenderContacts,
    warehouseContacts,
    vendorResponsibleContacts,
    facilityType,
    isAllContactTypesAreSelected,
    isAllContactTypesAreActive,
    address,
    locationName,
    isValidLocationName,
    selectedCity,
    selectedState,
    isAddressValidated,
    isAdditionalAddress,
    isValidRemarks,
  ]);

  isUpdateLocationButtonEnabled = validateUpdateAllMandatoryFields();
  function validateUpdateAllMandatoryFields() {
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }
    if (
      address &&
      locationName &&
      isValidLocationName &&
      // contactName &&
      // emailAddress &&
      // isValidEmail(emailAddress) &&
      // phoneNumber &&
      // isValidPhoneNumber &&
      isAllContactTypesAreSelected &&
      isAllContactTypesAreActive &&
      isValidRemarks &&
      selectedCity &&
      selectedState &&
      hasValidFieldsInAdditionalContacts(additionalContactsList) &&
      (facilityType !== "VENDOR_MANAGED" ||
        vendorResponsibleContacts.length === 0)
    ) {
      return true;
    }
    return false;
  }

  const validateContactTypesSelected = () => {
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }
    const requiredTypes =
      facilityType === "VENDOR_RESPONSIBLE"
        ? [...contactTypes, "VENDOR_RESPONSIBLE"]
        : contactTypes;

    const contactTypesMatched =
      additionalContactsList != null &&
      requiredTypes.every((type) =>
        additionalContactsList.some(
          (c) => c.jobTitle === type && c.operation !== "CD",
        ),
      );

    setIsAllContactTypesAreSelected(contactTypesMatched);
  };

  const validateContactTypesActive = () => {
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }
    const requiredTypes =
      facilityType === "VENDOR_RESPONSIBLE"
        ? [...contactTypes, "VENDOR_RESPONSIBLE"]
        : contactTypes;

    const contactTypesMatched =
      additionalContactsList != null &&
      requiredTypes.every((type) =>
        additionalContactsList.some(
          (c) => c.jobTitle === type && c.operation !== "CD" && c.active,
        ),
      );

    setIsAllContactTypesAreActive(contactTypesMatched);
  };

  const validateFaclityType = () => {
    if (facilityType === "") {
      setIsValidFacilityType(false);
    } else {
      setIsValidFacilityType(true);
    }
  };

  const cancel = () => {
    history.push({
      pathname: "/findLocation",
      state: { searchLocation: searchLocation },
    });
  };

  const goToNextInvalidField = () => {
    let additionalContactsList: AdditionalContactDetails[] = [];
    if (facilityType === "VENDOR_RESPONSIBLE") {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
        vendorResponsibleContacts,
      );
    } else {
      additionalContactsList = additionalContactsList.concat(
        releaseSummaryContacts,
        tenderContacts,
        warehouseContacts,
      );
    }

    if (!locationName) {
      focusOnField("locationNameInput");
    }
    // else if ( !(contactName) ) {
    //   focusOnField("contactNameInput");
    // }
    // else if ( !(emailAddress) ) {
    //   focusOnField("emailAddressInput");
    // }
    // else if ( !(phoneNumber) ) {
    //   focusOnField("phoneNumberInput");
    // }
    else if (!address) {
      focusOnField("streetAddressInput");
    } else if (!postalCode) {
      focusOnField("postalcodeInput");
    } else if (isValidateButtonEnabled) {
      focusOnButton("validateAddressButton");
    }
    // else if ( additionalContactsList?.some(hasInvalidName) ) {
    //   focusOnField("contactName" + additionalContactsList?.find(hasInvalidName)?.contactXid);
    // }
    // else if ( additionalContactsList?.some(hasInvalidEmail) ) {
    //   focusOnField("emailAddress" + additionalContactsList?.find(hasInvalidEmail)?.contactXid);
    // }
    // else if ( additionalContactsList?.some(hasInvalidPhone) ) {
    //   focusOnField("phoneNumber" + additionalContactsList?.find(hasInvalidPhone)?.contactXid);
    // }
    else if (hasTooManyActiveWarehouseContacts(additionalContactsList)) {
      additionalContactsList
        .filter(isActiveWarehouseContact)
        .forEach((additionalContact) => {
          focusOnField("contactName" + additionalContact.contactXid, true);
        });
    }
  };

  const validationError = (
    contacts: AdditionalContactDetails[],
    options?: { showWarehouseLimit?: boolean },
  ) => {
    const visibleContacts = contacts.filter(
      (contact) => contact.operation !== "CD",
    );
    const hasContact = visibleContacts.length > 0;
    const hasActiveContact = visibleContacts.some((contact) => contact.active);
    const warehouseLimitExceeded =
      options?.showWarehouseLimit &&
      hasTooManyActiveWarehouseContacts(contacts);

    if (hasContact && hasActiveContact && !warehouseLimitExceeded) {
      return;
    }

    return (
      <div className="validation-error">
        {!hasContact && (
          <>
            <span>
              &nbsp;&nbsp;&nbsp; There should be at least one contact of each
              contact type
            </span>
            <br />
          </>
        )}
        {hasContact && !hasActiveContact && (
          <>
            <span>
              &nbsp;&nbsp;&nbsp; There should be at least one active contact of
              each contact type
            </span>
            <br />
          </>
        )}
        {warehouseLimitExceeded && (
          <span>
            &nbsp;&nbsp;&nbsp; You cannot have more than three <b>active</b>{" "}
            warehouse contacts.
          </span>
        )}
      </div>
    );
  };

  return (
    <div id="newLocationPage">
      <section className="page-section clearfix">
        <div className="container">
          <div
            className="intro"
            style={{ width: "80%", marginRight: "auto", marginLeft: "auto" }}
          >
            <div id="locationManager" className="section-heading mb-4">
              <span
                className="section-heading-lower"
                style={{
                  fontSize: "2rem",
                  textAlign: "center",
                  color: "#6b3a06",
                  fontWeight: 500,
                  paddingBottom: "50px",
                }}
              >
                LOCATION MANAGER
              </span>
              <form>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "50%" }}>
                    <div className="form-group py-2">
                      <label id="vendoridLabel" className="form-label">
                        Corporation ID
                      </label>
                      <TextField
                        className="form-control"
                        id="vendorIdLabel"
                        value={vendorId}
                        variant="outlined"
                        disabled
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="locationIdLabel" className="form-label">
                        Location ID
                      </label>
                      <TextField
                        className="form-control"
                        value={
                          isMatm
                            ? !(loc !== undefined)
                              ? facilityId
                              : loc?.locationGId
                            : loc?.locationXId
                        } // Display facilityId when in MATM mode(isMatm is true); otherwise, display locationXId from the loc object if available.
                        variant="outlined"
                        disabled
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="locationNameLabel" className="form-label">
                        * Location Name
                      </label>
                      <FlagableTextField
                        id="locationNameInput"
                        variant="outlined"
                        className="form-control"
                        onChange={handleLocationName}
                        value={locationName}
                        required
                      />
                      {!isValidLocationName && (
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Maximum is 50 characters in Facility Name field.
                        </span>
                      )}
                      {loc !== undefined && (
                        <span
                          className="form-check form-switch"
                          style={{ color: isActive ? "green" : "gray" }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            checked={isActive}
                            onChange={handleIsActive}
                          />
                          {isActive ? "Active" : "Inactive"}
                        </span>
                      )}
                    </div>
                    {false && (
                      <div>
                        <div className="form-group py-2">
                          <label id="whContactNameLabel" className="form-label">
                            * Warehouse Contact Name
                          </label>
                          <FlagableTextField
                            id="contactNameInput"
                            variant="outlined"
                            className="form-control"
                            onChange={handleContactName}
                            value={contactName}
                            required
                          />
                        </div>
                        <div className="form-group py-2">
                          <label id="emailAddressLabel" className="form-label">
                            * Email Address
                          </label>
                          <FlagableTextField
                            id="emailAddressInput"
                            variant="outlined"
                            className="form-control"
                            onChange={handleEmailAddress}
                            value={emailAddress}
                            required
                          />
                          {emailAddress.trim().length > 0 &&
                            !isValidEmail(emailAddress) && (
                              <span
                                id="validateEmailMessage"
                                style={{ fontWeight: "bold", color: "red" }}
                              >
                                Email is not valid.
                              </span>
                            )}
                        </div>
                        <div className="form-group py-2">
                          <label id="phoneNumberLabel" className="form-label">
                            * Phone Number
                          </label>
                          <FlagableTextField
                            id="phoneNumberInput"
                            variant="outlined"
                            className="form-control"
                            onChange={handlePhoneNumber}
                            value={phoneNumber}
                            required
                          />
                          {!isValidPhoneNumber && (
                            <span style={{ fontWeight: "bold", color: "red" }}>
                              Phone number is 10 digits.
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="form-group py-2">
                      <label id="stateLabel" className="form-label">
                        * State/Province
                      </label>
                      <TextField
                        id="stateValue"
                        className="form-control"
                        value={selectedState}
                        variant="outlined"
                        disabled
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="postalcodeLabel" className="form-label">
                        * Postal Code
                      </label>
                      {showInputText && loc === undefined ? (
                        <FlagableTextField
                          id="postalcodeInput"
                          className="form-control"
                          onChange={handlePostalCode}
                          value={postalCode}
                          variant="outlined"
                          required
                        />
                      ) : (
                        <FlagableTextField
                          id="postalcodeInput"
                          className="form-control"
                          onChange={handlePostalCode}
                          value={postalCode}
                          variant="outlined"
                          disabled
                        />
                      )}
                    </div>
                    <div className="form-group py-2">
                      <label id="remarksLabel" className="form-label">
                        Default Shipping Origin Remarks
                      </label>
                      <TextField
                        id="remarksInput"
                        className="form-control"
                        value={remark}
                        onChange={handleRemark}
                        minRows={3}
                        multiline
                      />
                      {!isValidRemarks && (
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Maximum is 80 characters in remarks field.
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ width: "50%", marginLeft: "75px" }}>
                    <div className="form-group py-2">
                      <label id="calenderIdLabel" className="form-label">
                        Calender Id
                      </label>
                      <DropDown
                        codes={calenderIds}
                        className="form-control"
                        elementId="calenderId"
                        value={calenderId}
                        onChange={handleCalenderId}
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="streetAddressLabel" className="form-label">
                        * Street Address
                      </label>
                      {showInputText && loc === undefined ? (
                        <FlagableTextField
                          id="streetAddressInput"
                          className="form-control"
                          onChange={handleStreetAddress}
                          value={address}
                          variant="outlined"
                          required
                        />
                      ) : (
                        <FlagableTextField
                          id="streetAddressInput"
                          className="form-control"
                          onChange={handleStreetAddress}
                          value={address}
                          variant="outlined"
                          disabled
                        />
                      )}
                      {!isAddressValidated && (
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Maximum is 55 characters in Street Address field.
                        </span>
                      )}
                    </div>
                    <div className="form-group py-2">
                      <label id="cityLabel" className="form-label">
                        * City
                      </label>
                      <TextField
                        id="cityValue"
                        className="form-control"
                        value={selectedCity}
                        variant="outlined"
                        disabled
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="countyCodeLabel" className="form-label">
                        Country Code
                      </label>
                      <DropDown
                        codes={countryCodes}
                        elementId="countryCodeId"
                        value={countryCode}
                        disable={true}
                      />
                    </div>
                    <div className="form-group py-2">
                      <label id="facilityTypeLabel" className="form-label">
                        * Facility Type
                      </label>
                      <RadioGroup
                        row
                        value={facilityType}
                        onChange={handleFacilityType}
                      >
                        <FormControlLabel
                          value="VENDOR_MANAGED"
                          control={<Radio />}
                          label="Vendor Managed"
                        />
                        <FormControlLabel
                          value="VENDOR_RESPONSIBLE"
                          control={<Radio />}
                          label="3rd Party Managed"
                        />
                      </RadioGroup>
                      {!isValidFacilityType && (
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Facility Type is mandatory.
                        </span>
                      )}
                    </div>
                    <div className="form-group py-2">
                      <label id="additionalAddressLabel" className="form-label">
                        Additional Address Lines
                      </label>
                      <TextField
                        className="form-control"
                        id="additionalAddressInput"
                        value={additionalAddress}
                        onChange={handleAdditionalAddress}
                        minRows={3}
                        multiline
                      />
                      {!isAdditionalAddress && (
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Maximum is 50 characters in Additional Address Lines
                          field.
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <br />
          {isFetchingData && <progress max="100" id="progressBar" />}
          {showValidatedAddressPrompt ? (
            <AddressPrompt
              validatedAddress={validatedAddrResult}
              togglingPrompt={togglingPrompt}
              onSelectedAddress={onSelectedAddress}
            />
          ) : (
            <React.Fragment />
          )}
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              margin: "auto",
              alignItems: "center",
              padding: "10px",
            }}
          >
            {!(loc !== undefined) ? (
              <span>
                <Tooltip
                  title={
                    !isValidateButtonEnabled ? (
                      <h5>
                        Street address, Postal code and Facility type are
                        required
                      </h5>
                    ) : (
                      ""
                    )
                  }
                >
                  <span>
                    <FlagableButton
                      className="btn btn-primary"
                      onClick={validateAddress}
                      disabled={!isValidateButtonEnabled}
                      id="validateAddressButton"
                    >
                      Validate Address
                    </FlagableButton>
                  </span>
                </Tooltip>
              </span>
            ) : (
              ""
            )}
          </Box>

          <br />
          <LocationAvailability
            updateRefNumVal={updateRefNumVal}
            locAvailabilityFromApi={locAvailability}
          />
          <br />
          {!isLoading && (
            <div id="additionalContactsDiv">
              <Accordion defaultExpanded={true}>
                <div className="pageContent-style">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="pannel1a-content"
                  >
                    <h5>Release Summary Contacts</h5>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      title="Person that will receive a summary report on order release creation"
                    >
                      <InfoIcon id="releaseSummaryToolTip" />
                    </Tooltip>
                  </AccordionSummary>
                </div>
                <div className="pageContent-style">
                  <AccordionDetails>
                    <AdditionalContacts
                      showContactDetails={!showInputText}
                      defaultContactName={contactName}
                      defaultEmailAddress={emailAddress}
                      defaultPhoneNumber={phoneNumber}
                      defaultFacilityType={facilityType}
                      additionalContactsList={releaseSummaryContacts}
                      updateContactList={updateReleaseSummaryContactList}
                      operationType="RELEASE_SUMMARY"
                    ></AdditionalContacts>
                  </AccordionDetails>
                </div>
                {validationError(releaseSummaryContacts)}
              </Accordion>
            </div>
          )}
          <br />
          {!isLoading && (
            <div id="additionalContactsDiv">
              <Accordion defaultExpanded={true}>
                <div className="pageContent-style">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="pannel1a-content"
                  >
                    <h5>Tender Contacts</h5>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      title="Person that will receive bill of lading and instructions when shipment is assigned to carrier"
                    >
                      <InfoIcon id="tenderContactsToolTip" />
                    </Tooltip>
                  </AccordionSummary>
                </div>
                <div className="pageContent-style">
                  <AccordionDetails>
                    <AdditionalContacts
                      showContactDetails={!showInputText}
                      defaultContactName={contactName}
                      defaultEmailAddress={emailAddress}
                      defaultPhoneNumber={phoneNumber}
                      defaultFacilityType={facilityType}
                      additionalContactsList={tenderContacts}
                      updateContactList={updateTenderContactList}
                      operationType="TENDER"
                    ></AdditionalContacts>
                  </AccordionDetails>
                </div>
                {validationError(tenderContacts)}
              </Accordion>
            </div>
          )}
          <br />
          {!isLoading && (
            <div id="additionalContactsDiv">
              <Accordion defaultExpanded={true}>
                <div className="pageContent-style">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="pannel1a-content"
                  >
                    <h5>Warehouse Contacts</h5>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      title="Person that a carrier will contact when scheduling pick up appointments"
                    >
                      <InfoIcon id="warehouseContactsToolTip" />
                    </Tooltip>
                  </AccordionSummary>
                </div>
                <div className="pageContent-style">
                  <AccordionDetails>
                    <AdditionalContacts
                      showContactDetails={!showInputText}
                      defaultContactName={contactName}
                      defaultEmailAddress={emailAddress}
                      defaultPhoneNumber={phoneNumber}
                      defaultFacilityType={facilityType}
                      additionalContactsList={warehouseContacts}
                      updateContactList={updateWarehouseContactList}
                      operationType="WAREHOUSE"
                    ></AdditionalContacts>
                  </AccordionDetails>
                </div>
                {validationError(warehouseContacts, {
                  showWarehouseLimit: true,
                })}
              </Accordion>
            </div>
          )}
          <br />
          {!isLoading && facilityType === "VENDOR_RESPONSIBLE" && (
            <div id="additionalContactsDiv">
              <Accordion defaultExpanded={true}>
                <div className="pageContent-style">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="pannel1a-content"
                  >
                    <h5>Vendor Responsible Contacts</h5>
                    <Tooltip
                      disableFocusListener
                      disableTouchListener
                      title="Vendor contact who can help should Dollar Tree need to communicate with the vendor directly."
                    >
                      <InfoIcon id="vendorResponsibleToolTip" />
                    </Tooltip>
                  </AccordionSummary>
                </div>
                <div className="pageContent-style">
                  <AccordionDetails>
                    <AdditionalContacts
                      showContactDetails={true}
                      defaultContactName={contactName}
                      defaultEmailAddress={emailAddress}
                      defaultPhoneNumber={phoneNumber}
                      defaultFacilityType={facilityType}
                      additionalContactsList={vendorResponsibleContacts}
                      updateContactList={updateVendorResponsibleContactList}
                      operationType="VENDOR_RESPONSIBLE"
                    ></AdditionalContacts>
                  </AccordionDetails>
                </div>
                {validationError(vendorResponsibleContacts)}
              </Accordion>
            </div>
          )}
          <br />
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              margin: "auto",
              alignItems: "center",
              padding: "10px",
            }}
          >
            {!(loc !== undefined) ? (
              <span>
                <Tooltip
                  title={
                    !isCreateLocationButtonEnabled ? (
                      <h5>
                        Must fill mandatory fields, validate address, and
                        resolve any errors in Additional Contacts.
                      </h5>
                    ) : (
                      ""
                    )
                  }
                >
                  <span>
                    <div className="row justify-content-center m-xl-2">
                      <button
                        id="goToErrorsButton"
                        type="button"
                        className="btn"
                        style={{
                          width: "auto",
                        }}
                        disabled={isCreateLocationButtonEnabled}
                        onClick={() => goToNextInvalidField()}
                      >
                        {!isCreateLocationButtonEnabled
                          ? "Go to errors"
                          : "No errors"}
                      </button>
                    </div>
                    <button
                      className="btn btn-primary"
                      onClick={() => createOrUpdateLocation("create")}
                      disabled={!isCreateLocationButtonEnabled}
                      id="createLocationButton"
                    >
                      Create Location
                    </button>
                  </span>
                </Tooltip>
              </span>
            ) : (
              <span>
                <Tooltip
                  title={
                    !isUpdateLocationButtonEnabled ? (
                      <h5>
                        Must fill mandatory fields and resolve any errors in
                        Additional Contacts.
                      </h5>
                    ) : (
                      ""
                    )
                  }
                >
                  <span>
                    <button
                      className="btn btn-primary"
                      disabled={!isUpdateLocationButtonEnabled}
                      onClick={() => createOrUpdateLocation("update")}
                      id="updateLocationButton"
                    >
                      Update Location
                    </button>
                  </span>
                </Tooltip>
                &nbsp;
                <button
                  id="cancelButton"
                  className="btn btn-dark"
                  onClick={() => cancel()}
                >
                  Back
                </button>
                &nbsp;
                {false && (
                  <button
                    id="deleteLocationButton"
                    className="btn btn-danger"
                    disabled={!isUpdateLocationButtonEnabled}
                    onClick={() => openDialog()}
                  >
                    Delete Location
                  </button>
                )}
              </span>
            )}
          </Box>
        </div>
        <div id="deleteDialogLocation">
          <Dialog open={open} onClose={closeDialog}>
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                id="searchLocationButton"
                onClick={closeDialog}
                color="primary"
                autoFocus
              >
                No
              </Button>
              <Button
                id="searchLocationButton"
                onClick={() => deleteLocation()}
                color="primary"
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id="alertDialog">
          <Dialog open={openAlert} id="statusDialog">
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText>{dialogContent}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                id="statusDialogButton"
                onClick={closeAlertDialog}
                color="primary"
                autoFocus
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id="validationAlert">
          <Dialog open={validationAlert} id="validationAlertDialog">
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText>{dialogContent}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                id="validationAlertButton"
                onClick={closeValidationAlert}
                color="primary"
                autoFocus
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
};

export default NewLocationPage;
